// pagina de editare participanti inscrisi

import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import withRouter from "../../components/routerhoc";
import axios from "axios";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
//css
import "../../css/style.css";
import theme from "../../css/theme";

const EditMember = props => {
  const currentMember = useLocation();
  console.log(`curent member= `, currentMember);

  const [name, setName] = useState("");
  const [firstname, setFirstname] = useState("");
  const [sex, setSex] = useState(null);
  const [race, setRace] = useState(null);
  const [team, setTeam] = useState("");
  const [message, setMessage] = useState(false);
  const [lastMemberID, setLastMemberID] = useState(null);
  const navigate = useNavigate();
  const currentUser = useSelector(state => state.auth);
  const { user_id, user_type } = currentUser;

  const loadState = () => {
    setName(currentMember.state.name);
    setFirstname(currentMember.state.firstname);
    setSex(currentMember.state.sex);
    setRace(currentMember.state.race);
    setTeam(currentMember.state.team);
  };

  useEffect(() => {
    if (user_type === "GUEST") {
      navigate("/login");
    }
    try {
      if (currentMember && currentMember.state && currentMember.state.member_id) {
        console.log(`ruleaza LOADSTATE`);
        loadState();
        return;
      }
      return;
    } catch (error) {
      console.error(`error la useEffect`, error);
    }
  }, [user_id]);

  console.log(`curent state: name:${name}, firstname: ${firstname} , sex: ${sex} , race: ${race}, team: ${team} `);

  const handleName = event => {
    setName(event.target.value);
  };

  const handleFirstname = event => {
    setFirstname(event.target.value);
  };

  const handleSex = event => {
    setSex(event.target.value);
  };

  const handleRace = event => {
    if (event.target.value !== "") {
      setRace(event.target.value);
    }
  };

  const handleTeam = event => {
    setTeam(event.target.value);
  };

  const onSave = () => {
    const newMember = {
      name: name,
      firstname: firstname,
      sex: sex,
      race: race,
      team: team,
      user_id: user_id,
    };

    if (name !== "" && firstname !== "" && sex && race) {
      console.log(
        `ADD new member: => name:${name}, firstname ${firstname} , sex ${sex}, race ${race}, team ${team}, user_id ${user_id}`
      );
      axios
        .post("/api/user/add", newMember)
        .then(response => {
          setLastMemberID(response.data.member_id);
          setMessage(true);
          setName("");
          setFirstname("");
          setSex(null);
          setRace(null);
          setTeam("");
        })
        .catch(error => {
          console.error(`Axios error /api/user/add : `, error);
        });
    }
  };

  const onCancel = () => {
    setMessage(false);
    setName("");
    setFirstname("");
    setSex(null);
    setRace(null);
    setTeam("");
  };

  const onEdit = () => {
    // http localhost:5001/api/user/edit/9
    // name="Membru Editat" firstname="Echipa edit 4" sex="F" race="peste 45" team="individual" user_id:=4 -v
    const editedMember = {
      ...currentMember.state,
      name: name,
      firstname: firstname,
      sex: sex,
      race: race,
      team: team,
    };
    console.log(`EDITED MEMBER OBj = `, editedMember);

    if (name !== "" && firstname !== "" && sex && race) {
      console.log(`RULEAZA AXIOS EDIT`, editedMember);
      //console.log(`EDITED new state for user_id: ${editedMember.user_id} si member_id:${editedMember.member_id}: => name:${name}, firstname ${firstname} , sex ${sex}, race ${race}, team ${team}`);
      console.log(
        `EDITED new state for user_id:${editedMember.user_id} si member_id:${editedMember.member_id}: => name:${name}, firstname ${firstname} , sex ${sex}, race ${race}, team ${team}`
      );

      axios
        .post(`/api/user/edit/${editedMember.member_id}`, editedMember)
        .then(response => {
          // ****************************
          setLastMemberID(response.data.member_id);
          setMessage(true);
          setName("");
          setFirstname("");
          setSex(null);
          setRace(null);
          setTeam("");
        })
        .catch(error => {
          console.error(`Axios error /api/user/edit : `, error);
        });
    }
  };

  const onReturn = () => {
    navigate(`/members/${user_id}`);
  };
  return (
    <div className="edit-member-container">
      {message && <div>A fost adaugat membrul {lastMemberID}</div>}
      <div className="text-fields">
        <div>
          <TextField
            className="textfield"
            required
            id="outlined-required"
            label="Nume"
            name="name"
            value={name}
            onChange={handleName}
          />
        </div>
        <div>
          <TextField
            className="textfield"
            required
            id="outlined-required"
            label="Prenume"
            name="firstname"
            value={firstname}
            onChange={handleFirstname}
          />
        </div>
      </div>

      <div className="edit-member-radio-group-container">
        <FormControl required>
          <FormLabel className="edit-member-label" id="demo-row-radio-buttons-group-label" required name="sex">
            Sex
          </FormLabel>

          <RadioGroup
            column
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="sex"
            required
            value={sex}
            onChange={handleSex}
          >
            <FormControlLabel
              className="edit-member-radio-button"
              value="feminin"
              control={<Radio />}
              label="Feminin"
            />

            <FormControlLabel
              className="edit-member-radio-button"
              value="masculin"
              control={<Radio />}
              label="Masculin"
            />
          </RadioGroup>
        </FormControl>
      </div>
      <div className="edit-member-radio-group-container">
        <FormControl>
          <FormLabel className="edit-member-label" id="demo-row-radio-buttons-group-label" required name="race">
            Cursa
          </FormLabel>

          <RadioGroup
            column
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="race"
            required
            value={race}
            onChange={handleRace}
          >
            <FormControlLabel value="echipe" control={<Radio />} label="Echipe" />
            <FormControlLabel value="individual sub 45 ani" control={<Radio />} label="Individual sub 45 ani" />
            <FormControlLabel value="individual peste 45 ani" control={<Radio />} label="Individual peste 45 ani" />
          </RadioGroup>
        </FormControl>
      </div>
      <div className="extra-margin">
        <TextField
          className="textfield"
          required
          id="outlined-required"
          label="Numele echipei"
          name="team"
          value={team}
          onChange={handleTeam}
        />
      </div>

      <div>
        <Button className="admin-buttons" variant="contained" theme={theme} type="submit" onClick={onSave}>
          Adauga
        </Button>

        <Button className="admin-buttons" variant="contained" theme={theme} type="submit" onClick={onEdit}>
          Salveaza
        </Button>

        <Button className="admin-buttons" variant="contained" theme={theme} type="submit" onClick={onCancel}>
          Anuleaza
        </Button>

        <Button className="admin-buttons" variant="contained" theme={theme} type="submit" onClick={onReturn}>
          Inapoi
        </Button>
      </div>
    </div>
  );
};

export default withRouter(EditMember);
